import { Typography } from '@mui/material'
import styles from '../AdminConfigsPage.module.scss'

function RiskAlertLevel({ label, level }) {
	if (!level) return null
	return (
		<div className={styles.riskLevel}>
			<Typography component="h4" className={styles.configSubheading}>
				{label}
			</Typography>
			{level.msg != null && (
				<p className={styles.configValue}>
					<strong>Message:</strong> {level.msg}
				</p>
			)}
			{level.trigger_time != null && (
				<p className={styles.configValue}>
					<strong>Trigger time:</strong> {level.trigger_time}
				</p>
			)}
		</div>
	)
}

function RiskAlertDetails({ riskAlert }) {
	if (!riskAlert || typeof riskAlert !== 'object') {
		return (
			<p className={styles.configValueMuted}>No notification config</p>
		)
	}

	const alert = riskAlert
	return (
		<div className={styles.riskAlertBlock}>
			<Typography component="h3" className={styles.configSubheading}>
				Notification config (riskAlert)
			</Typography>
			<RiskAlertLevel label="Red" level={alert.red} />
			<RiskAlertLevel label="Yellow" level={alert.yellow} />
			<RiskAlertLevel label="Green" level={alert.green} />
			{alert.context != null && (
				<p className={styles.configValue}>
					<strong>Context:</strong> {alert.context}
				</p>
			)}
			{alert.action != null && (
				<p className={styles.configValue}>
					<strong>Action:</strong> {alert.action}
				</p>
			)}
			{alert.button_text != null && (
				<p className={styles.configValue}>
					<strong>Button text:</strong> {alert.button_text}
				</p>
			)}
			{alert.action_link != null && (
				<p className={styles.configValue}>
					<strong>Action link:</strong> {alert.action_link}
				</p>
			)}
		</div>
	)
}

export function TaskConfigDetails({ task, showPatch = false }) {
	return (
		<div className={styles.configDetails}>
			<dl className={styles.configDl}>
				{task.taskId != null && (
					<>
						<dt>Task ID</dt>
						<dd>{task.taskId}</dd>
					</>
				)}
				{task.planning_stage != null && (
					<>
						<dt>Planning stage</dt>
						<dd>{task.planning_stage}</dd>
					</>
				)}
				{task.vendor_category != null && (
					<>
						<dt>Vendor category</dt>
						<dd>{task.vendor_category}</dd>
					</>
				)}
				{task.task != null && (
					<>
						<dt>Task</dt>
						<dd>{task.task}</dd>
					</>
				)}
				{task.min_days != null && (
					<>
						<dt>Min days</dt>
						<dd>{task.min_days}</dd>
					</>
				)}
				{task.max_days != null && (
					<>
						<dt>Max days</dt>
						<dd>{task.max_days}</dd>
					</>
				)}
				{task.order != null && (
					<>
						<dt>Order</dt>
						<dd>{task.order}</dd>
					</>
				)}
			</dl>
			<RiskAlertDetails riskAlert={task.riskAlert} />
			{showPatch && task.hasPatch && task.patch && (
				<div className={styles.patchBlock}>
					<Typography component="h3" className={styles.configSubheading}>
						Overrides default
					</Typography>
					<pre className={styles.patchJson}>
						{JSON.stringify(task.patch, null, 2)}
					</pre>
				</div>
			)}
		</div>
	)
}
